import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 40,
          borderRadius: theme.shape.borderRadius,
          boxShadow: 'none',
          gap: theme.spacing(1),
          whiteSpace: 'nowrap',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeSmall: {
          minHeight: 32,
          padding: theme.spacing(0.5, 1.5),
        },
        sizeMedium: {
          minHeight: 40,
          padding: theme.spacing(0.75, 2),
        },
        sizeLarge: {
          minHeight: 48,
          padding: theme.spacing(1, 2.5),
        },
        startIcon: {
          marginLeft: 0,
        },
        endIcon: {
          marginRight: 0,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          // boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400],
          },
        },
        containedPrimary: {
          // boxShadow: theme.customShadows.primary,
        },
        containedSecondary: {
          // boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
